module.exports = __webpack_public_path__ + "img/rcgysq_zcnr.be2cc823.png";